import React from 'react';
import { OnboardingStep } from '../onboarding.types';
import { OnboardingClasses } from '../onboarding.enums';

export const PRODUCT_LIST_TOUR: OnboardingStep[] = [
    {
        className: OnboardingClasses.PRODUCT_CARD,
        placement: 'right',
        title: 'Product Card',
        borderRadius: 10,
        content: (
            <>
                Great job!
                <br />
                Here is your very first and shiny product.
                <br />
                Products are represented as cards with the most essential
                product information available at hands.
            </>
        ),
        nextOnTargetClick: true,
    },
    {
        className: OnboardingClasses.CONTROL_PANEL,
        placement: 'right',
        title: 'Control Panel',
        borderRadius: 10,
        content: (
            <>
                This is product&#39;s control panel. you will see a lot of it in
                Travelity.
                <br />
                Control panel gives you immediate access to certain actions.
            </>
        ),
    },
    {
        className: OnboardingClasses.PREVIEW_ICON,
        placement: 'right',
        nextOnTargetClick: true,
        title: 'Preview',
        borderRadius: 10,
        content: <>Preview will open the entire product for you to review.</>,
    },
    {
        className: OnboardingClasses.PRODUCT_PREVIEW_PANEL,
        waitForTarget: true,
        placement: 'left',
        title: 'Product Preview',
        content: (
            <>
                You can explore each and every section this product has and
                amend data if necessary.
            </>
        ),
    },
    {
        className: OnboardingClasses.DUPLICATE_BUTTON,
        placement: 'right',
        title: 'Duplicate',
        borderRadius: 10,
        content: (
            <>
                Duplication will let you copy and modify similar products in a
                fast and smooth way.
            </>
        ),
    },
    {
        className: OnboardingClasses.DELETE_BUTTON,
        placement: 'right',
        title: 'Delete',
        borderRadius: 10,
        content: (
            <>
                If you don&#39;t need this product anymore, you can simply
                delete.
            </>
        ),
    },
];
